import React from "react";
import { CircularProgress } from "@material-ui/core";
import "./selectable-list.css";

/**
 * SelectableListPure
 *
 * Props:
 * - items             {Array}    Array de objetos. Por defecto espera { id, fullName }.
 * - value             {Array}    Array de ids actualmente seleccionados.
 * - onSelectionChange {Function} Callback (ids: string[]) => void
 * - multiple          {Boolean}  Permite selección múltiple. Default: true.
 * - loading           {Boolean}  Muestra spinner mientras carga.
 * - labelKey          {String}   Propiedad del objeto a mostrar como texto. Default: "fullName".
 * - valueKey          {String}   Propiedad a usar como identificador único. Default: "id".
 * - label             {String}   Título encima de la lista.
 * - emptyMessage      {String}   Mensaje cuando items está vacío.
 * - disabled          {Boolean}  Deshabilita toda la lista.
 *
 * Uso con usersByPermission:
 * <SelectableListPure
 *   items={usersByPermission}
 *   value={selectedUsers}
 *   onSelectionChange={setSelectedUsers}
 *   multiple
 *   loading={loadingUsers}
 *   label="Usuarios del grupo"
 * />
 */
const SelectableListPure = ({
  items = [],
  value = [],
  onSelectionChange,
  multiple = true,
  loading = false,
  labelKey = "fullName",
  valueKey = "id",
  label,
  emptyMessage = "No hay elementos disponibles",
  disabled = false,
}) => {
  const handleToggle = (itemId) => {
    if (disabled) return;

    if (multiple) {
      const currentIndex = value.indexOf(itemId);
      const newSelected = [...value];
      if (currentIndex === -1) {
        newSelected.push(itemId);
      } else {
        newSelected.splice(currentIndex, 1);
      }
      onSelectionChange && onSelectionChange(newSelected);
    } else {
      const newSelected = value[0] === itemId ? [] : [itemId];
      onSelectionChange && onSelectionChange(newSelected);
    }
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="selectable-list-loading">
          <CircularProgress size={24} />
        </div>
      );
    }

    if (!items || items.length === 0) {
      return (
        <div className="selectable-list-empty">
          {emptyMessage}
        </div>
      );
    }

    return (
      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {items.map((item) => {
          const itemId = item[valueKey];
          let itemLabel = item[labelKey];
          if(itemLabel.trim() === "") itemLabel = item['email'] // Si el label está vacío, mostrar el id
          const isSelected = value.includes(itemId);
          const isDisabled = disabled || item.disabled;

          return (
            <li
              key={itemId}
              onClick={() => !isDisabled && handleToggle(itemId)}
              className={[
                "selectable-list-item",
                isSelected ? "selectable-list-item--selected" : "",
                isDisabled ? "selectable-list-item--disabled" : "",
              ].join(" ").trim()}
            >
              <input
                type="checkbox"
                readOnly
                checked={isSelected}
                tabIndex={-1}
                className="selectable-list-item__checkbox"
              />
              <span className="selectable-list-item__text">{itemLabel}</span>
            </li>
          );
        })}
      </ul>
    );
  };

  return (
    <div className="selectable-list-wrapper">
      {label && (
        <span className="eticket-form-label">{label}</span>
      )}
      <div className="selectable-list-paper">
        {renderContent()}
      </div>
    </div>
  );
};

export { SelectableListPure as default };


